import React from "react";
import { Dropdown } from "semantic-ui-react";
import { PermissionCheck } from "components/auth";
import {
  DeleteDocumentModal,
  DownloadDocumentModal,
  EditDocumentModal,
  SendDocumentToAppModal,
} from "components/modals";
import { Actions, Targets } from "constants/Permissions";
import {
  deleteEnquiryDocument,
  getEnquiryDocument,
  updateEnquiryDocument,
  updateEnquiryDocumentSendToApp,
} from "./actions";
import { DocumentTypesDropdown } from "components/forms";

const EnquiryDocumentTableActions = ({
  document,
  enquiryId,
  departmentId,
  onRefresh,
}) => (
  <Dropdown
    icon="ellipsis vertical"
    pointing="top left"
    className="icon"
    aria-label="Document actions"
    title="Document actions"
  >
    <Dropdown.Menu>
      <PermissionCheck target={Targets.EnquiryDocument} action={Actions.View}>
        <DownloadDocumentModal
          document={document}
          action={getEnquiryDocument}
          actionParams={{ enquiryId }}
          as={Dropdown.Item}
        >
          Download Document
        </DownloadDocumentModal>
      </PermissionCheck>
      {!document.isReadOnly && (
        <PermissionCheck target={Targets.EnquiryDocument} action={Actions.Edit}>
          <EditDocumentModal
            document={document}
            submitAction={updateEnquiryDocument}
            submitParams={{ enquiryId }}
            onUpdated={onRefresh}
            documentTypeDropdown={
              <DocumentTypesDropdown
                field="documentTypeId"
                label="Type"
                departmentId={departmentId}
                placeholder="Select document type"
                required
                fluid
              />
            }
            as={Dropdown.Item}
          >
            Edit Document
          </EditDocumentModal>
        </PermissionCheck>
      )}

      <PermissionCheck target={Targets.EnquiryDocument} action={Actions.Edit}>
        <SendDocumentToAppModal
          document={document}
          submitAction={updateEnquiryDocumentSendToApp}
          submitParams={{ enquiryId }}
          sendDescription="It will be sent to the app with any job converted from this enquiry from now on. Existing jobs are not changed."
          stopDescription="It will not be sent to the app with any job converted from this enquiry from now on. Existing jobs are not changed."
          onUpdated={onRefresh}
          as={Dropdown.Item}
        >
          {document.sendToApp ? "Do Not Send to App" : "Send to App"}
        </SendDocumentToAppModal>
      </PermissionCheck>

      <PermissionCheck target={Targets.EnquiryDocument} action={Actions.Delete}>
        <DeleteDocumentModal
          document={document}
          action={deleteEnquiryDocument}
          actionParams={{ enquiryId }}
          onDeleted={onRefresh}
          as={Dropdown.Item}
        >
          Delete Document
        </DeleteDocumentModal>
      </PermissionCheck>
    </Dropdown.Menu>
  </Dropdown>
);

export default EnquiryDocumentTableActions;
